import { createSlice } from "@reduxjs/toolkit";
import {
  activateDeactivateRoles,
  createRole,
  deleteRole,
  fetchAllPages,
  fetchAllRoles,
  fetchPageTableColumnNames,
  fetchRoleTableColumnNames,
  updatePagePermission,
  updateRoles,
} from "./thunk";

const rolesSlice = createSlice({
  name: "roles",
  initialState: {
    roles: [],
    pagePermission: [],
    tableColumnNames: [],
    pageTableColumnNames: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder

      // Fetch Role Table Column Names API
      .addCase(fetchRoleTableColumnNames.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRoleTableColumnNames.fulfilled, (state, action) => {
        state.loading = false;
        state.tableColumnNames = action.payload;
      })
      .addCase(fetchRoleTableColumnNames.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get All rioles
      .addCase(fetchAllRoles.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllRoles.fulfilled, (state, action) => {
        state.loading = false;
        state.roles = action.payload;
      })
      .addCase(fetchAllRoles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Role API
      .addCase(createRole.pending, (state) => {
        // state.loading = true;
        state.error = null;
      })
      .addCase(createRole.fulfilled, (state, action) => {
        // state.loading = false;
        state.roles = [action.payload.data[0], ...state.roles];
      })
      
      .addCase(createRole.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.payload;
      })

      // Update Role API
      .addCase(updateRoles.pending, (state) => {
        // state.loading = true;
        state.error = null;
      })
      .addCase(updateRoles.fulfilled, (state, action) => {
        // state.loading = false;
        const index = state.roles.findIndex(
          (item) => item.ID === action.payload[0].ID
        );

        if (index !== -1) {
          state.roles[index] = action.payload[0];
        }
      })
      .addCase(updateRoles.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.payload;
      })

      // Role screen API
      .addCase(deleteRole.pending, (state) => {
        // state.loading = true;
        state.error = null;
      })
      .addCase(deleteRole.fulfilled, (state, action) => {
        // state.loading = false;
        // Extract IDs from the payload
        const deletedIds = action.payload.map((item) => item.ID);

        // Filter out the deleted items
        state.roles = state.roles.filter(
          (item) => !deletedIds.includes(item.ID)
        );

        // toast.success("Deleted successfully");
      })
      .addCase(deleteRole.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.payload;
      })

      // Active Deactive roles
      .addCase(activateDeactivateRoles.pending, (state) => {
        // state.loading = true;
        state.error = null;
      })
      .addCase(activateDeactivateRoles.fulfilled, (state, action) => {
        // state.loading = false;

        if (action.payload) {
          // Ensure payload exists
          const updatedRole = action.payload; // API returns only the updated role

          const index = state.roles.findIndex(
            (item) => item.ID === updatedRole.ID
          );

          if (index !== -1) {
            state.roles[index] = {
              ...state.roles[index],
              IsActive: updatedRole.IsActive,
            };
          }
        }
      })
      .addCase(activateDeactivateRoles.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.payload;
      })

      // Fetch Page Permission Table Column Names API
      .addCase(fetchPageTableColumnNames.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPageTableColumnNames.fulfilled, (state, action) => {
        state.loading = false;
        state.pageTableColumnNames = action.payload;
      })
      .addCase(fetchPageTableColumnNames.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get All Page permission
      .addCase(fetchAllPages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllPages.fulfilled, (state, action) => {
        state.loading = false;
        state.pagePermission = action.payload;
      })
      .addCase(fetchAllPages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update Page Permission
      .addCase(updatePagePermission.pending, (state) => {
        // state.loading = true;
        state.error = null;
      })
      .addCase(updatePagePermission.fulfilled, (state, action) => {
        // state.loading = false;

        state.pagePermission = state.pagePermission.map((page) =>
          page.PageId === action.payload[0].pageId
            ? { ...page, ...action.payload[0] }
            : page
        );
      })

      .addCase(updatePagePermission.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.payload;
      });
  },
});

export default rolesSlice.reducer;
